import React from "react";

const Logo = () => {
  return (
    <div className="logo-container">
      <div className="logo-icon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="60"
          height="60"
          viewBox="0 0 64 64"
          fill="none"
        >
          <circle cx="32" cy="18" r="10" stroke="#2E8BC0" strokeWidth="4" />
          <line
            x1="32"
            y1="28"
            x2="32"
            y2="44"
            stroke="#2E8BC0"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <line
            x1="32"
            y1="44"
            x2="24"
            y2="54"
            stroke="#2E8BC0"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <line
            x1="32"
            y1="44"
            x2="40"
            y2="54"
            stroke="#2E8BC0"
            strokeWidth="4"
            strokeLinecap="round"
          />
          <line
            x1="24"
            y1="36"
            x2="40"
            y2="36"
            stroke="#2E8BC0"
            strokeWidth="4"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="logo-text">Humanize</div>
    </div>
  );
};

export default Logo;